import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { LoaderService } from "@services/loader.service";

@Component({
    selector: "app-spinner",
    templateUrl: "./spinner.component.html",
    styleUrls: ["./spinner.component.scss"],
    standalone: false
})
export class SpinnerComponent implements OnInit {
  loading: boolean | undefined;

  constructor(
    private loaderService: LoaderService,
    public cd: ChangeDetectorRef
  ) {
    this.loaderService.isLoading.subscribe((v) => {
      setTimeout(() => {
        this.loading = v;
      });
    });
  }
  ngOnInit() {}
}
